module.exports = __webpack_public_path__ + "img/logo.37bb1803.png";